import React from "react";
import ScheduleGrid from "/imports/ui/components/scheduleGrid";
import { weekDatesFrom, weekDayColumns, buildDayItems } from "/imports/ui/components/scheduleGrid/gridHelpers";
import WeekBookingBlock from "./components/WeekBookingBlock";

// The trainer dashboard's own week: a thin wrapper over the shared
// ScheduleGrid with 7 day columns. Layout math lives in scheduleGrid; the
// block visuals (attendance accent, tap → attendance or note dialog) stay here.
function TrainerWeekGrid({ days = [], weekStart, todayYmd, timeZone, onMark, onNote }) {
  const dates = weekDatesFrom(weekStart);
  const byDate = buildDayItems(days);
  const itemsByColumn = Object.fromEntries(dates.map((d) => [d, byDate.get(d) || []]));

  return (
    <ScheduleGrid
      columns={weekDayColumns(dates, todayYmd)}
      itemsByColumn={itemsByColumn}
      BlockComponent={WeekBookingBlock}
      blockProps={{ onMark, onNote }}
      autoScrollToKey={todayYmd}
      nowColumnKeys={todayYmd ? [todayYmd] : []}
      timeZone={timeZone}
    />
  );
}

export default TrainerWeekGrid;
